import { useMissionDetailingStore } from '../../store/useMissionDetailingStore';
import { ChaptersList } from '../chapters-list';

export const Chapters = () => {
  const missionPage = useMissionDetailingStore((state) => state.missionPage);

  if (!missionPage) {
    return null;
  }

  const headerComponent = () => {
    return (
      <div className="mb-sh-15">
        <h2 className="mb-2 font-cadiz text-sh-28-32 font-bold">{missionPage?.chaptersArea?.title}</h2>
        <p className="font-cadiz text-sh-xs">{missionPage?.chaptersArea?.description}</p>
      </div>
    );
  };
  return <ChaptersList headerComponent={headerComponent} />;
};
